import { type FieldProps, useRecordContext } from "react-admin";
import { Typography } from "@mui/material";
import get from "lodash/get";
import { AUTOVIO_SUPPORTED_LANGUAGES } from "../inputs/TheoryExamLanguageInput";

export function TheoryExamLanguageField(props: { source: string; emptyText?: string } & FieldProps) {
  const { source, emptyText } = props;
  const record = useRecordContext(props);
  if (!record) return null;
  const value = get(record, source);

  const language = AUTOVIO_SUPPORTED_LANGUAGES.find(([code]) => code === value)?.[1];

  return (
    <Typography component="span" variant="body2">
      {language ?? emptyText ?? "-"}
    </Typography>
  );
}
